import { render } from "./UserAuditLogs.vue?vue&type=template&id=c815bda4&scoped=true"
import script from "./UserAuditLogs.vue?vue&type=script&lang=js"
export * from "./UserAuditLogs.vue?vue&type=script&lang=js"

import "./UserAuditLogs.vue?vue&type=style&index=0&id=c815bda4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c815bda4"]])

export default __exports__